import React from 'react';
import { Button } from 'antd';
import { useCommentsState } from '../../../../../../../providers/Comments';
import styles from './styles.module.css';
import { getLangKey } from '../../../../../../models/Language';
import * as translations from '../../strings';

const strings = translations[getLangKey()];

const PAGE_SIZE = 100;

export const ShowMore = () => {
  const { page, setPage, comments, commentsLoading } = useCommentsState();

  if (commentsLoading || page * PAGE_SIZE > comments.length) return null;

  return (
    <div className={styles.showMoreContainer}>
      <Button
        type="link"
        className={styles.showMoreButton}
        onClick={() => setPage(page + 1)}
      >
        {strings.showMore}
      </Button>
    </div>
  );
};
